import {
  fetchAuthSession,
} from '@aws-amplify/auth';

import { cdnApiClient } from './cdnApiClient';
import { cdnApiPath } from './cdnApiPaths';

export const getCurrentSession = async () => {
  try {
    return await fetchAuthSession();
  } catch (err) {
    return Promise.reject(err);
  }
};

/**
 * Returns the Cognito Access Token (JWT) for calling Seagull API.
 * @returns string | null
 */
export const getCognitoAccessToken = async () => {
  try {
    const { tokens } = await fetchAuthSession(); // throws if signed out
    return tokens?.accessToken?.toString() ?? null;
  } catch {
    return null;
  }
};

export const getSeagullUser = () => cdnApiClient.request(cdnApiPath('user'));

export const updateSeagullUser = (updatedUser) => cdnApiClient.request(
  cdnApiPath('user'),
  { method: 'PUT', body: updatedUser },
);

export const deleteSeagullUser = () => cdnApiClient.request(
  cdnApiPath('user'),
  { method: 'DELETE' },
);
